/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "./store";

interface IFilterState {
  // isLoading: boolean;
  startDate: string;
  endDate: string;
}
const formatedDate = (date: Date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(
    date.getDate()
  ).padStart(2, "0")}`;
const today = new Date();
const yesterday = new Date(today);
yesterday.setDate(yesterday.getDate() - 1);
const initialState: IFilterState = {
  // isLoading: false,
  startDate: formatedDate(yesterday),
  endDate: formatedDate(today),
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setStartDate(state, action) {
       if (action.payload && (action.payload as any).isFromFinance) {
         const now = new Date(); // compute now at call-time
         const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
         state.startDate = formatedDate(firstDayOfMonth);
       } else {
         state.startDate = action.payload;
       }
    },

    setEndDate(state, action) {
      state.endDate = action.payload;
    },
    clearFilter(state) {
      state.startDate = "";
    },
    resetFilter(state) {
      state.startDate = initialState.startDate;
      state.endDate = initialState.endDate;
    },
    // filterLoading(state, action) {
    //   console.log("ChekingLaodingStates2", action.payload);
    //   state.isLoading = action.payload;
    // }
  },
});

// selectors
export const { setStartDate, setEndDate, resetFilter, clearFilter } = filterSlice.actions;
export const selectFilterSlice = (state: RootState) => state.filter;
export default filterSlice.reducer;
